export default __webpack_public_path__ + "static/media/stakeholder-map-template.9d06fd19.pdf";